import { Hotel } from "@/internal/modules/providers/interfaces/Hotel";
import { defineStore } from "pinia";
import { ref } from "vue";

export const useGroupHotelsStore = defineStore("groupHotels", () => {
  const hotels = ref<Hotel[]>([]);

  return {
    hotels,

    setHotels(newHotels: Hotel[]) {
      hotels.value = newHotels;
    },
  };
});
